<template>
    <Breadcrumbs main="Apps" title="Pre Interview" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <prejoining />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const prejoining = defineAsyncComponent(() => import("@/components/front-office/pre-interview/pre-join.vue"))
</script>